<template>
  <div class="pc-page">
    <div class="top-wrap">
      <div class="top">
        <img class="logo" src="./../../../assets/png/pc/logo.png" alt="">
        <img class="cdn" src="./../../../assets/png/pc/cdn.png" alt="">
      </div>
    </div>
    <div v-if="showImg">
      <img
        v-for="(item, index) in urlList1"
        :key="index"
        :src="item.url"
        width="1"
        height="1"
        @error="autoTest(item, index)"
        style="display: none"
      />
    </div>
    <div class="container">
      <div class="app-list">
        <div :class="['item', 'item' + index]" v-for="(item, index) in urlList" :key="index">
          <div @click.stop="tolinkUrl(item.url)" class="toapp-btn"></div>
          <div v-if="item.webUrl" @click.stop="tolinkUrl(item.webUrl)" class="toweb-btn"></div>
        </div> 
      </div>
      <div class="title">推荐应用</div>
      <div class="app-list1">
        <div :class="['item', 'item' + index]" v-for="(item, index) in urlList1" :key="index">
          <div class="timeConsuming">
            <span v-if="item.time == 0">检测中...</span
            ><span v-else
              ><span v-if="item.time < 50" class="green"
                >{{ item.time }}MS</span
              >
              <span v-if="item.time >= 50 && item.time < 100" class="orange"
                >{{ item.time }}MS</span
              >
              <span v-if="item.time >= 100" class="red"
                >{{ item.time }}MS</span
              ></span
            >
          </div>
          <div @click.stop="tolinkUrl(item.url)" class="toapp-btn"></div>
          <div v-if="item.webUrl" @click.stop="tolinkUrl(item.webUrl)" class="toweb-btn"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  name: "mobile",
  data() {
    return {
      urlList: [
       { time: 0, name: '欲漫涩', url: 'https://d15cdp17wrtows.cloudfront.net', webUrl: 'https://d1s8wm47asyysy.cloudfront.net' },
        { time: 0, name: '萝莉岛', url: 'https://d34oag60mr723b.cloudfront.net', webUrl: 'https://d1q6v0m0fmxvl0.cloudfront.net' },
        { time: 0, name: '麻豆', url: 'https://d11dszr8awyru3.cloudfront.net', webUrl: 'https://d2m1d86x8ze4id.cloudfront.net' },
        { time: 0, name: '海角乱伦', url: 'https://d2fmhutt07loza.cloudfront.net', webUrl: 'https://doyj68zud8dgm.cloudfront.net' },
        { time: 0, name: 'pornhub中文版', url: 'https://d1b52d1w8md9bt.cloudfront.net', webUrl: 'https://d2o7c2qy2lvgf1.cloudfront.net' },
        { time: 0, name: 'xvideos', url: 'https://d39qpqkr0a2imh.cloudfront.net', webUrl: 'https://d4yzu2s8mrrvk.cloudfront.net' },

        { time: 0, name: '91porn', url: 'https://d3tcv930f7tqpi.cloudfront.net'},
        { time: 0, name: '萝莉岛', url: 'https://d1alfixdmc8fv0.cloudfront.net', webUrl: 'ttps://d2xw96fnbwxopk.cloudfront.net'},
        { time: 0, name: 'pornhub精品版', url: 'https://d2fd46yiy3nduv.cloudfront.net' },
        { time: 0, name: '妖精漫画', url: 'https://dl94i45mkvo19.cloudfront.net/' },
        { time: 0, name: 'YouTube', url: 'https://d25bo9n7ztxk1a.cloudfront.net' },
        { time: 0, name: '91暗网', url: 'https://d3uq99hs0j28bm.cloudfront.net', webUrl: 'https://dh0n7f6bcnjxj.cloudfront.net' },
        { time: 0, name: '好色', url: 'https://d2vx9rpf9ijb2i.cloudfront.net', webUrl: 'https://d39cmeitkp3imu.cloudfront.net' },
        { time: 0, name: 'Soul', url: 'https://d3p20kuldfl13e.cloudfront.net', webUrl: 'https://d1u1x3yp88ozd.cloudfront.net' },
        { time: 0, name: '禁漫', url: 'https://d5bqarj6n2jmu.cloudfront.net' },
        { time: 0, name: '逼哩逼哩', url: 'https://d2z5pcp3hj41t5.cloudfront.net'},
      ],
      urlList1: [
         { time: 0, name: 'XVideos破解版', url: 'https://d3pnpac3b9l22f.cloudfront.net' },
        { time: 0, name: '波多', url: 'https://dla3s0q3qoa32.cloudfront.net' },
        { time: 0, name: '妻友', url: 'https://d3q2ufgkab6tdl.cloudfront.net' },

        { time: 0, name: '快手', url: 'https://d1rmio2ivfomt8.cloudfront.net' },
        { time: 0, name: 'XV暗网', url: 'https://d1dmpfqy7tcvam.cloudfront.net/' },
         { time: 0, name: '黑料社', url: 'https://d16ztykhxkw4bu.cloudfront.net/' },
        { time: 0, name: 'Tiktok成人版', url: 'https://d25xaxdudb28l6.cloudfront.net/' },
        { time: 0, name: '禁漫', url: 'https://d5bqarj6n2jmu.cloudfront.net' },
        { time: 0, name: 'YouTube', url: 'https://d25bo9n7ztxk1a.cloudfront.net' },
      ],
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    }
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
    tolinkUrl(url) {
      const routeDc = this.$route.query.dc
      if (routeDc) {
        window.open(url + '?dc=' + routeDc);
      } else {
        const dc = process.env.VUE_APP_WEB_DC || 985
        window.open(url + '?dc=' + dc);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.pc-page {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: url('./../../../assets/png/pcbg.webp') center;
  background-size: cover;
  .top-wrap {
    background: #1A1A1A;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
    height: 78PX;
    margin-bottom: 24px;
  }
  .top {
    width: 1265PX;
    height: 78PX;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;

    .logo {
      width: 140PX;
      height: 40PX;
    }

    .cdn {
      width: 191PX;
      height: 42PX;
    }
  }
  .container {
    width: 1265PX;
    height: 100%;
    margin: auto;
  }

  .app-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 14PX;

    .item {
      width: 145PX;
      height: 224PX;
      cursor: pointer;
      transform: scale(1);
      transition: all 0.5s;
      position: relative;
      .toapp-btn {
        width: 55px;
        height: 24px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .toweb-btn {
        width: 40px;
        height: 24px;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }

    .item:hover {
      transform: scale(1.05);
      transition: all 0.5s;
    }

    @for $i from 0 through 15 {
      .item#{$i} {
        background: url('./../../../assets/png/pc/img/#{$i}.png');
        background-size: 100% 100%;
      }
    }
  }

  .title {
    color: #fff;
    font-size: 24PX;
    font-weight: 500;
    line-height: 34PX;
    margin-top: 30PX;
    margin-bottom: 21PX;
  }

  .app-list1 {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    gap: 14PX;

    .item {
      width: 410PX;
      height: 96PX;
      cursor: pointer;
      transform: scale(1);
      transition: all 0.4s;
    }
    .toapp-btn {
      width: 60PX;
      height: 26PX;
      position: absolute;
      bottom: 35PX;
      right: 9PX;
    }
    .toweb-btn {
      width: 60PX;
      height: 26PX;
      position: absolute;
      bottom: 35PX;
      right: 84PX;
    }
    .item:hover {
      transform: scale(1.03);
      transition: all 0.4s;
    }

    @for $i from 0 through 8 {
      .item#{$i} {
        background: url('./../../../assets/png/pc/img1/#{$i}.png');
        background-size: 100% 100%;
      }
    }
  }
}

.timeConsuming {
  color: #31ffe4;
  font-size: 12PX;
  position: absolute;
  bottom: 16PX;
  left: 92PX;
  width: 50PX;
  background: #10121d;
}
.green {
  color: #31ffe4;
}
.orange {
  color: #f5a937;
}
.red {
  color: #e93333;
}
</style>
